$(document).ready(function() {
    if ($("#product-image-gallery").length > 0) {
      setTimeout(function() {
        $("#product-image-gallery div:not(:first-child) img").show();
      }, 120);
    }
    if ($(".subtype-selector-test").length > 0) {
      $(".subtype-selector span").on("click", function() {
        $(".subtype-selector span.active").removeClass("active");
        $(this).addClass("active");
        var subtype = $(this).attr("data-filter"); 
        $(".subtypeselector:not(.original-hidden)").hide();
        $(".subtypeselector.subtype-"+subtype+":not(.original-hidden)").show();

        if (subtype == "vegan") {
          $("#nutrition-facts-vegan").show();
          $("#nutrition-facts").hide();
          $(".product-pack-7-block-vegan").show();
          $(".product-pack-7-block").hide();
          
          
        }else {
          $("#nutrition-facts-vegan").hide();
          $("#nutrition-facts").show();
          ű$(".product-pack-7-block-vegan").hide();
          $(".product-pack-7-block").show();
          
        }
        
      });
    }
    $(".open-more-tags").on("click", function() {
      $(".more-tags").slideToggle();
    });
    if ($(".blog-page").length > 0 ) {
      $(".blog-page-content img").each(function() {
        $(this).attr("data-aos","flip-left");
      });
      AOS.init();
    }
    if ($(".slideshow-owl").length > 0) {
      initHomeSliderShow();
    }
    if ($(".form__input.cart-list__input.cart__qty-input").length > 0) {
      $(".form__input.cart-list__input.cart__qty-input").on("change", function() {
        initCartReloadTimer();
        
      })
    }
   if ($("#stamped-reviews-widget").length > 0) {
     $("#stamped-reviews-widget").on("click", function() {
       $('html, body').animate({
                    scrollTop: $("#stamped-main-widget").offset().top
                }, 2000);
     })
   }
   if ($("#stamped-main-widget-preload").length > 0) {
      setTimeout(function() {
        loadStampedBox();
      }, 10000);
   }
   if (document.querySelector("#faq-nulls-content")) {
     var org = document.querySelector("#faq-nulls-content");
     var trg = document.querySelector("#faq-nulls-content-section");
     trg.innerHTML=org.innerHTML;
   }

   if ($("#fixed-cart").length > 0 && $(".fixed-cart-container").length > 0) {
      /*initFixedCart();*/
    }
  
    initMenuScroll();
    
    
  
    
});
function fixedCartClick(original_id) {
  console.log(original_id);
  if (original_id == "AddToCart-product-template-28-pack") {
       $('html, body').animate({
            scrollTop: $(".product-selection__list").offset().top-250
        }, 1000);
    return true;
  }
  if (original_id == "AddToCart-product-template-21days") {
       $("#start-dialog-cart").trigger("click");
    return true;
  }
  if (original_id == "AddToCart-template--20391226605914__main"  || original_id == "AddToCart-template--20391226474842__main") {
       $('html, body').animate({
            scrollTop: $(".product-selection__radio-group").offset().top-250
        }, 1000);
    return true;
  }

  
  $('#'+original_id).trigger('click');
}
function initFixedCart() {
  var cart_html = $(".fixed-cart-container").html();
  var original_btn = $(".fixed-cart-container button");
  original_id = original_btn.attr("id");
  var title_html = "<div class='col-6'><b>"+$(".product-selection__heading.heading").html()+"</b><div id='fixed-cart-stamped'></div></div>";
  cart_html = "<div class='col-6 text-right'>"+cart_html+"</div>";
  $("#fixed-cart").html("<div class='container'><div class='row'>"+title_html+""+cart_html+"</div></div>");
  $("#fixed-cart button").removeAttr("disabled").attr("onclick", "fixedCartClick('"+original_id+"');").attr("id", "fixed-cart-button");
  $("#fixed-cart button").removeClass("button--disabled");
  if (original_id == "AddToCart-product-template-21days") {
    $("#fixed-cart button .placeholder").hide();
    $("#fixed-cart button .price-item.price-item--sale ").html("Elkészítem a csomagom!");
    $("#fixed-cart button .price-item.price-item--regular").hide();
    $("#fixed-cart button .divider").hide();
  }

  
  $("#fixed-cart-stamped").on("click", function() { $('html, body').animate({
                    scrollTop: $("#stamped-main-widget").offset().top
                }, 2000);});
  var cart_position = $(".fixed-cart-container").offset().top + 10;
  $(window).scroll(function () {
        if ($(document).scrollTop() > cart_position) {    
            
              $("#fixed-cart").addClass("cart-scrolled");    
              $(".admin-bar").remove();
              if ($("#fixed-cart-stamped").html() == "") {
                var stamped = $("#stamped-reviews-widget").html();
                $("#fixed-cart-stamped").html(stamped);
                
              }
        } else {
            $("#fixed-cart").removeClass("cart-scrolled");
        }
    });
  
}

function loadStampedBox() {
    $("#stamped-main-widget-preload").html('<div id="stamped-main-widget" class="stamped-main-widget stamped-style-borderless" data-widget-style="2-columns"> </div>');
   StampedFn.reloadUGC();
}

var cartreloadtimer;
function initCartReloadTimer() {
  if (cartreloadtimer) {
    clearTimeout(cartreloadtimer);
    
  }
 
  cartreloadtimer = setTimeout(function() {
    $(".cart__update-link.link.link--underline.cart__update").trigger("click");
   
  }, 1000);

 
}

function initMenuScroll() {
  var menu_orignal_height = $(".shopify-section-group-header-group").height();
  $(window).scroll(function () {
        if ($(document).scrollTop() > 100) {
            $("header").height(menu_orignal_height);
            $(".shopify-section-group-header-group").addClass("scrolled");
          
        } else {
            $(".shopify-section-group-header-group").removeClass("scrolled");
        }
    });
}
function resizeSliderShow() {
  var original_width = 1400;
    var original_height = 600;
    var original_mobilewidth = 800;
    var original_mobileheight = 1200;
  
  var current_width = $(this).width();
        
         if (current_width > 850) {
           var new_ratio = (current_width/original_width);
           $(".slideshow-wrapper").css("max-width", original_width*new_ratio);
           $(".slideshow-wrapper, .slideshow-owl .slideshow__image,.slideshow-owl .owl-item,.slideshow-owl").css("height", original_height*new_ratio).css("min-height", original_height*new_ratio);
           $(".slideshow-owl .slideshow__image").each(function(){
             
             $(this).css("background-image", "url("+$(this).attr("data-desktopbg")+")");
           })
         }else {
          
           var new_ratio = (current_width/original_mobilewidth);
           $(".slideshow-wrapper").css("max-width", original_mobilewidth*new_ratio);
           $(".slideshow-wrapper, .slideshow-owl .slideshow__image,.slideshow-owl .owl-item,.slideshow-owl").css("height", original_mobileheight*new_ratio).css("min-height", original_mobileheight*new_ratio);
           $(".slideshow-owl .slideshow__image").each(function(){
             
             $(this).css("background-image", "url("+$(this).attr("data-mobilebg")+")");
           })
         }
}
function initHomeSliderShow() {
    resizeSliderShow();
    $(window).on('resize', function(){
         resizeSliderShow();
    
    });

  
 var home_owl = $('.slideshow-owl').owlCarousel({
    loop:false,
   lazyLoad: true,
    margin:0,
    nav:false,
    autoplay:true,
    autoplayTimeout:6000,
    autoplayHoverPause:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        },
        10000:{
            items:1
        }
    }
});
  home_owl.on('touchstart', 'img', function(e) {
	$(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
});
home_owl.on('touchend', 'img', function(e) {
	$(this).closest('.owl-carousel').trigger('play.owl.autoplay');
});
home_owl.on('click', '.owl-dots, .owl-nav', function(e) {
	$(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
	$(this).closest('.owl-carousel').trigger('play.owl.autoplay');
});
}
showFooterMessage();
function showFooterMessage() {
  var url = new URL(document.location.href);
  var c = url.searchParams.get("customer_posted");
 
  if (c == "true") {
    setTimeout(function() {
      $("#newsletter-success").show();
      $("#contact_form .form__row").hide();
      $("#contact_form .form__footer").hide();
      $("#contact_form .checkbox").attr("style", "display:none !important;");
                          }, 200);
  }
}